import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import './MobileHero.css';

const MobileHero = () => {
  return (
    <Box className="mobile-hero">
      <div className="mobile-hero-overlay" />
      <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <motion.div
          className="mobile-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="subtitle1"
            className="mobile-hero-subtitle-top"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Our Services
          </Typography>
          <Typography
            variant="h1"
            className="mobile-hero-title"
            component={motion.h1}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            MOBILE APP DEVELOPMENT
          </Typography>
          <Typography
            className="mobile-hero-description"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Create powerful, user-friendly mobile applications that engage your audience 
            and drive business growth. Our expert team develops native and cross-platform 
            solutions that deliver exceptional user experiences across all devices.
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default MobileHero; 